<table class="mdl-data-table mdl-js-data-table mdl-shadow--2dp monitoring-table" style="table-layout: fixed;">
    <thead>
        <tr>
            <th style="width: 5%" class="header-cell" title="#">#</th>
            <th style="width: 5%" class="header-cell" title="Id">Id</th>
            <th style="width: 25%" class="header-cell" title="Old Gridics Id">Old Gridics Id</th>
            <th style="width: 25%" class="header-cell" title="New Gridics Id">New Gridics Id</th>
            <th style="width: 8%" class="header-cell" title="Zoning Codes">Zoning Codes</th>
            <th style="width: 8%" class="header-cell" title="Zoning Code Versions">ZC Versions</th>
            <th style="width: 8%" class="header-cell" title="PR Places">PR Places</th>
            <th style="width: 8%" class="header-cell" title="PR Land Uses">PR Land Uses</th>
            <th style="width: 8%" class="header-cell" title="PR Zoning Codes">PR Zoning Codes</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let combinedReplaceIdStatistic of combinedReplaceIdStatistics; let i = index"
            app-replace-land-use-ids-row [combinedReplaceIdStatistic]="combinedReplaceIdStatistic" [index]="i+1"></tr>
    </tbody>
</table>